<template lang="pug">
  #mailsetting(role='tabpanel', aria-labelledby='recmail-tab')
    .col-xs-6
      h4 通知先メールアドレスの設定
      p お問い合わせがきた際に通知するメールアドレスを設定します。
      .form-group
        label.h5.control-label(for='mail') 宛先
        input#mail.form-control(v-model='form.notification_to' type='text' placeholder='受信するメールアドレスを入力'
        v-bind:class='{invalid:$v.form.notification_to.$dirty && $v.form.notification_to.$invalid}'
        @input='$v.form.notification_to.$touch')
        span.error(v-show='$v.form.notification_to.$dirty && $v.form.notification_to.$invalid')
          p(v-show='!$v.form.notification_to.required') 必須項目です
          p(v-show='!$v.form.notification_to.email') 不正なメールアドレスです
      .form-group
        label.h5.control-label(for='cc_mail') CC
        input#cc_mail.form-control(v-model='form.notification_cc' type='text' placeholder='CCで受信するメールアドレスを入力'
        v-bind:class='{invalid:$v.form.notification_cc.$invalid}')
        span.error(v-show='$v.form.notification_cc.$invalid')
          p(v-show='!$v.form.notification_cc.email') 不正なメールアドレスです
      .form-group
        label.h5.control-label(for='bcc_mail') BCC
        input#bcc_mail.form-control(v-model='form.notification_bcc' type='text' placeholder='BCCで受信するメールアドレスを入力'
        v-bind:class='{invalid:$v.form.notification_bcc.$invalid}')
        span.error(v-show='$v.form.notification_bcc.$invalid')
          p(v-show='!$v.form.notification_bcc.email') 不正なメールアドレスです
    .col-xs-12
      hr
      h4 自動返信メールの設定
      p
        | お問い合わせがきた際に相手に自動返信するメール内容を設定します。
        br
        | （下記のメールサーバ情報で設定したメールアドレスから送信されます）
    .col-xs-8
      .form-group
        label.h5.control-label(for='mail_subject') 件名
        input#mail_subject.form-control(v-model='form.thanks_title' type='text' placeholder='メールの件名を入力'
        v-bind:class='{invalid:$v.form.thanks_title.$dirty && $v.form.thanks_title.$invalid}'
        @input='$v.form.thanks_title.$touch')
        span.error(v-show='$v.form.thanks_title.$dirty && $v.form.thanks_title.$invalid')
          p(v-show='!$v.form.thanks_title.required') 必須項目です
          p(v-show='!$v.form.thanks_title.maxLength') 100文字以下で入力してください
    .col-xs-10
      .form-group
        label.h5.control-label(for='mail_text') 本文
        textarea#mail_text.form-control(v-model='form.thanks_header' rows='10' placeholder='メールの本文を入力'
        v-bind:class='{invalid:$v.form.thanks_header.$dirty && $v.form.thanks_header.$invalid}'
        @input='$v.form.thanks_header.$touch')
        span.error(v-show='$v.form.thanks_header.$dirty && $v.form.thanks_header.$invalid')
          p(v-show='!$v.form.thanks_header.required') 必須項目です
      .form-group
        label.h5.control-label(for='inquirycontents_plug')
          input#inquirycontents_plug.checkbox01-input(type='checkbox' v-model='form.include_inquiry_body' v-bind:true-value='1' v-bind:false-value='0')
          span.checkbox01-parts
          span お問い合わせ内容を差し込む
      .form-group
        label.h5.control-label(for='mail_footer') フッター
        textarea#mail_footer.form-control(v-model='form.thanks_footer' rows='5' placeholder='メールのフッターを入力')
      .form-group
        label.h5.control-label(for='mail_signature') 署名
        textarea#mail_signature.form-control(v-model='form.default_signature' rows='5' placeholder='メールの署名を入力')
    .col-xs-12
      hr
      h4 メールサーバ設定
      p
        | メールを送信する際に使用するメールアドレス情報を設定します。
        br
        | （分からない場合は社内のサーバ責任者の方にお問い合わせください）
    .col-xs-6
      .form-group
        label.h5.control-label(for='send_mail') メールアドレス
        input#send_mail.form-control(v-model='form.smtp_mail_address' type='text' placeholder='メールアドレスを入力してください'
        v-bind:class='{invalid:$v.form.smtp_mail_address.$dirty && $v.form.smtp_mail_address.$invalid}'
        @input='$v.form.smtp_mail_address.$touch')
        span.error(v-show='$v.form.smtp_mail_address.$dirty && $v.form.smtp_mail_address.$invalid')
          p(v-show='!$v.form.smtp_mail_address.required') 必須項目です
          p(v-show='!$v.form.smtp_mail_address.email') 不正なメールアドレスです
          p(v-show='!$v.form.smtp_mail_address.maxLength') 100文字以下で入力してください
      .form-group
        label.h5.control-label(for='smtpserver') 送信メールサーバ
        input#smtpserver.form-control(v-model='form.smtp_server' type='text' placeholder='サーバ情報を入力してください'
        v-bind:class='{invalid:$v.form.smtp_server.$dirty && $v.form.smtp_server.$invalid}'
        @input='$v.form.smtp_server.$touch')
        span.error(v-show='$v.form.smtp_server.$dirty && $v.form.smtp_server.$invalid')
          p(v-show='!$v.form.smtp_server.required') 必須項目です
          p(v-show='!$v.form.smtp_server.ascii') 半角英数記号で入力してください
          p(v-show='!$v.form.smtp_server.maxLength') 100文字以下で入力してください
      .form-group
        label.h5.control-label(for='smtpport') SMTPポート
        input#smtpport.form-control(v-model='form.smtp_port' type='text' placeholder='ポート番号を入力してください'
        v-bind:class='{invalid:$v.form.smtp_port.$dirty && $v.form.smtp_port.$invalid}'
        @input='$v.form.smtp_port.$touch')
        span.error(v-show='$v.form.smtp_port.$dirty && $v.form.smtp_port.$invalid')
          p(v-show='!$v.form.smtp_port.required') 必須項目です
          p(v-show='!$v.form.smtp_port.numeric') 半角数字で入力してください
          p(v-show='!$v.form.smtp_port.maxLength') 4文字以下で入力してください
      .form-group
        label.h5.control-label(for='smtpsecure') SMTPセキュア
        .radio02
          input#radio03-01.radio02-input(v-model='form.smtp_secure' type='radio', value='', name='radio03')
          label(for='radio03-01') なし
          input#radio03-02.radio02-input(v-model='form.smtp_secure' type='radio', value='tls', name='radio03')
          label(for='radio03-02') TLS
      .form-group
        label.h5.control-label(for='mailaccount') アカウント名
        input#mailaccount.form-control(v-model='form.smtp_user' type='text' placeholder='アカウント名を入力してください'
        v-bind:class='{invalid:$v.form.smtp_user.$dirty && $v.form.smtp_user.$invalid}'
        @input='$v.form.smtp_user.$touch')
        span.error(v-show='$v.form.smtp_user.$dirty && $v.form.smtp_user.$invalid')
          p(v-show='!$v.form.smtp_user.required') 必須項目です
          p(v-show='!$v.form.smtp_user.ascii') 半角英数記号で入力してください
          p(v-show='!$v.form.smtp_user.maxLength') 50文字以下で入力してください
      .form-group
        label.h5.control-label(for='mailpassword') パスワード
        input#mailpassword.form-control(v-model='form.smtp_pass' type='text' placeholder='パスワードを入力してください'
        v-bind:class='{invalid:$v.form.smtp_pass.$dirty && $v.form.smtp_pass.$invalid}'
        @input='$v.form.smtp_pass.$touch')
        span.error(v-show='$v.form.smtp_pass.$dirty && $v.form.smtp_pass.$invalid')
          p(v-show='!$v.form.smtp_pass.required') 必須項目です
          p(v-show='!$v.form.smtp_pass.ascii') 半角英数記号で入力してください
          p(v-show='!$v.form.smtp_pass.maxLength') 50文字以下で入力してください
    .col-xs-12
      .setting-button
        a.customsmallbutton.btn.btn-info(type='button' name='send-test' @click='preSend' style='display:none') 送受信テスト
        a.customsmallbutton.btn.btn-success(type='button' @click='save') 保&nbsp;存
</template>

<style lang="stylus" scoped>
</style>

<script>
import $ from 'jquery'
import Authenticate from '@/service/Authenticate'
import Request from '@/service/Request'
import Loader from '@/service/Loader'
import qs from 'querystring'
import Message from '@/service/Message'
import { required, email, numeric, maxLength } from 'vuelidate/lib/validators'
import { ascii } from '@/validators'

export default {
  props: ['data'],
  data () {
    return {
      form: this.data
    }
  },
  validations: {
    form: {
      // notification_to: { required, email, maxLength: maxLength(100) },
      notification_to: { required, email },
      notification_cc: { email },
      notification_bcc: { email },
      thanks_title: { required, maxLength: maxLength(100) },
      thanks_header: { required },
      smtp_mail_address: { required, email, maxLength: maxLength(200) },
      smtp_server: { required, ascii, maxLength: maxLength(200) },
      smtp_port: { required, numeric, maxLength: maxLength(4) },
      smtp_user: { required, ascii, maxLength: maxLength(50) },
      smtp_pass: { required, ascii, maxLength: maxLength(50) }
    }
  },
  mounted () {
    // 入力チェックの変更感知（テスト送信ボタンの制御）
    this.$watch('$v.form.$invalid', function (boolean) {
      if (!boolean) { // OK
        $('a[name=send-test]').show()
      } else {  // NG
        $('a[name=send-test]').hide()
      }
    })
  },
  computed: {
  },
  created () {
  },
  methods: {
    preSend () {
      // 送信テストボタンを押すことができる -> 送信に必要となる情報は入力済みの想定
      let settings = {
        title: this.$parent.title,
        notification_to: this.form.notification_to,  // 問い合わせメール及びthanksメールのテスト受信用
        notification_cc: this.form.notification_cc,
        notification_bcc: this.form.notification_bcc,
        include_inquiry_body: this.form.include_inquiry_body,   // 問い合わせ内容を本文へ差し込むチェック
        thanks_title: this.form.thanks_title,
        thanks_header: this.form.thanks_header,
        thanks_footer: this.form.thanks_footer,
        default_signature: this.form.default_signature,
        smtp_mail_address: this.form.smtp_mail_address,
        smtp_server: this.form.smtp_server,
        smtp_port: this.form.smtp_port,
        smtp_secure: this.form.smtp_secure,
        smtp_user: this.form.smtp_user,
        smtp_pass: this.form.smtp_pass
      }
      this.$nextTick(() => { Loader.show() })
      Request.create(true).put('/form/pre_mailsend', settings)
        .then((res) => {
          Message.success(['テストメールを送信しました', '設定が未保存の場合、保存ボタンを押下してください'])
          this.$nextTick(() => { Loader.hide() })
        }).catch((err) => {
          Message.error(err.response.data.message)
          this.$nextTick(() => { Loader.hide() })
        })
    },
    save () {
      // 入力チェック
      if (this.$v.form.$invalid) {
        Message.show('error', ['入力内容に不備があります'])
        // 必須にtouchする
        this.$v.$touch()
        return false
      }
      // データ送信
      this.$nextTick(() => { Loader.show() })
      let axios = Request.instance(true)
      let currentUser = Authenticate.currentUser()
      let self = this
      axios.put('/form/' + this.form.id + '/mail',
        qs.stringify({
          formMail: JSON.stringify(this.form),
          user: JSON.stringify(currentUser)
        })
      ).then((res) => {
        // 更新完了後に親のbind methodをcall
        self.$parent.bind()
        Message.show('success', ['更新しました'])
      }).catch((res) => {
        this.$nextTick(() => { Loader.hide() })
        // dashboardへメッセージを送信
        Message.success(res.response.data.message)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// Mail.vue?5c839ce7